<template>
  <router-view/>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  @font-face{
    font-family: 'PingFang';
    src: url('./assets/icon/PingFang-Medium.ttf');
    /*src: local('PingFang Regular'),*/
    /*local('PingFang Regular'),*/
    /*url('./assets/icon/PingFang Regular.woff') format('woff'),*/
    /*url('./assets/icon/PingFang Regular.ttf') format('truetype'),*/
    /*url('./assets/icon/PingFang Regular.svg#PingFang Regular') format('svg');*/
  }
  html{
    font-family: 'PingFang';
  }
  button{
    font-family: 'PingFang';
  }
  html,body,div,ul,li {
    margin: 0;
    padding: 0;
  }
  table{
    color: #333;
    font-size: 14px;
  }
  th{
    font-size: 14px;
    color: #777;
    font-weight: normal;
    padding: 8px 0!important;
    /*border-top: 1px solid #eaeaea;*/
  }
  .el-table .cell{
    padding: 0 15px;
  }
  .el-form-item__label{
    font-size: 14px!important;
    font-weight: bold;
    color: #444!important;
    padding-right: 5px;
    /*text-align: left;*/
  }
  .el-input-group__append{
    background-color: #3e64ff;
    border: 1px solid #3e64ff;
    color: #fff;
  }
  .el-switch__core{
    width: 30px!important;
    height: 15px;
  }
  .el-switch__core:after{
    width: 11px;
    height: 11px;
  }
  .el-table__body tr.current-row>td {
    background-color: #e5f1ff;
  }
  .el-switch.is-checked .el-switch__core::after{
    margin-left: -12px;
  }
  .el-textarea textarea{
    min-height: 67px!important;
  }
  .el-dialog{
    width: 700px;
  }
  /*a{*/
    /*color: #3e64ff!important;*/
    /*text-decoration: underline!important;*/
  /*}*/
  input:focus,input.is-active,.el-checkbox__inner:hover{
    border-color: #DCDFE6!important;
  }
  /*.el-range-editor--small .el-range-separator,.el-range-editor--small .el-range__close-icon, .el-range-editor--small .el-range__icon{*/
  /*line-height: 31px;*/
  /*}*/
  .el-input--suffix .el-input__inner{
    padding-right: 25px;
  }
  .el-button{
    padding:8px 12px;
    font-size: 14px!important;
    color: #fff;
    background-color: #3e64ff;
    border: none;
  }
  .el-button:hover, .el-button:focus{
    background-color: #377eff;
    color: #fff;
  }
  .el-input input{
    height: 33px;
  }
  .el-table--border::after, .el-table--group::after, .el-table::before {
    content: '';
    position: absolute;
    background: none;
    z-index: 1;
  }
  .el-table--border{
    border: none;
  }
  .el-table--border td, .el-table--border th{
    border-right: 0;
  }
  .clearfix:after,.clearfix:before{
    content: " ";
    display: table;
  }
  .clearfix:after{
    clear:both;
  }
  .clearfix{
    *zoom:1;
  }
  .fr {
    float: right;
  }
  .fl {
    float: left;
  }
  .el-select-dropdown__item.selected {
    /*color: #0ec6a1;*/
    font-weight: 700;
  }
  .page{
    background-color: #fff;
    padding: 10px 20px;
  }
  .el-pagination__editor.el-input .el-input__inner{
    height: 28px!important;
  }
  .page li{
    color: #555;
  }
  .dialog-footer,.filter-button{
    margin-left: 10px;
    margin-right: 0!important;
  }
  .body_container{
    padding: 25px;
    min-height: 908px;
    background-color: #f4f7f9;
  }
  .right_menu_opened{
    background-color: #fff;
  }
  .right_menu{
    background-color: #fff;
    width: 60px;
  }
  .menu-icon{
    width: 16px;
    height: 16px;
    vertical-align: middle;
    fill: currentColor;
    overflow: hidden;
  }
  .menu-icon #qb-icon-lvshiguanli,.menu-icon #qb-icon-tongzhi,.menu-icon #qb-icon-xitongguanli1,.menu-icon #qb-icon-rizhi1{
    color:#888 ;
  }
  .menu-list span{
    color:#888;
    font-size: 15px;
  }
  .menu-list .el-submenu__title{
    padding: 0 22px;
  }
  .menu-list .el-submenu__title .el-submenu__icon-arrow{
    right:20px;
    top:57%;
  }
  .el-submenu__title{
    position: relative;
  }
  .blue_dot{
    width:9px;
    height: 9px;
    background-color: rgba(0,50,255,.8);
    border-radius: 50%;
    position: absolute;
    left: 27px;
    bottom: 19px;
    display: none;
  }
  .menu-list .el-submenu__title:hover,.menu-list.is-active{
    background-color:#e2e8ff;
  }
 .menu-list:focus span,.menu-list.is-active span{
    color: #333;
    font-weight: bold;
  }
  .menu-list.is-active i{
    color: #333;
  }
  .menu-list.is-active .blue_dot{
    display: block;
  }
  .menu-list .el-menu{
    background-color: #fff;
  }
  .menu-list .el-menu-item{
    font-size: 14px;
  }
  .menu-list .el-menu--inline .el-menu-item{
    color:#888;
    padding-left: 41px!important;
    height: 40px;
    line-height: 40px;
  }

  .menu-list .el-menu .el-menu-item:hover,.menu-list .el-menu .el-menu-item:focus,.menu-list .el-menu .el-menu-item.is-active{
    background-color:#fff;
    color: #3e64ff;
    font-weight: bold;
    border-right: 2px solid #3e64ff;
    box-sizing: border-box;
  }
  .menu-list .el-tooltip:focus{
    outline: 0;
  }
  .el-menu--popup-right-start{
    margin: 0;
  }
  .menu-list .el-tooltip .el-menu-item{
    padding-left: 0!important;
  }
  .el-submenu .el-menu-item{
    min-width: 168px;
  }
  .nav-top{
    height: 70px!important;
    line-height: 70px;
    border-bottom: 1px solid #f0f0f0;
    background-color: #fff;
    box-shadow: 0 0 5px rgba(0,0,0,.1);
    z-index: 999;
  }
  .el-button-icon{
    border-top:0;
    border-bottom: 0;
    border: none;
    padding: 14px 14px;
    color:#888;
  }
  .el-button-icon .el-dropdown{
    color:#888;
  }
  .el-button-icon:focus{
    color: #888;
    background-color: #fff;
  }
  .el-button-icon:hover,.el-button-icon .el-dropdown:hover{
    color: #409EFF;
    background-color: #fff;
  }
  /*登录页*/
  .login-bg{
    background: url("./assets/img/login-bg.png");
    height: 100vh;
  }
  .login-content {
    width: 850px;
    height: 550px;
    background: url("./assets/img/login-left.png") no-repeat;
    border-radius: 5px;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
  }
  .login-content .login-content-right{
    width: 460px;
    padding: 0 20px;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: -390px;
    margin: auto;
  }
  .login_form label{
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }
  .el-checkbox__label{
    font-weight: 400;
  }
  .login_form input{
    height: 30px;
    background-color: #fff;
    border: none;
    border-bottom: 1px solid #eaeaea;
    border-radius: 0;
    padding: 0;
    color: #333;
  }
  .el-form-item__content{
    line-height: 30px;
  }
  .login-content-right .el-form button{
    width: 420px;
    height: 40px;
    border-radius: 5px;
    font-size: 18px!important;
    background-color: #3e64ff;
  }
  /*直播*/
  .body_title{
    height: 45px;
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }
  .search_result{
    padding: 0;
    border-radius: 5px;
    background-color: #fff;
  }

  .el-tree-node__expand-icon{
    display: none;
  }
  .role_list tr{
    cursor: pointer;
  }
  /*.el-tree-node__content{*/
    /*padding-left: 0!important;*/
  /*}*/

  .search_result .cell{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
</style>




// WEBPACK FOOTER //
// src/App.vue